import { render, staticRenderFns } from "./TestAxios.vue?vue&type=template&id=57e83a94"
import script from "./TestAxios.vue?vue&type=script&lang=js"
export * from "./TestAxios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports